import { Component, OnInit } from '@angular/core';
import { PeerReviewService } from '../../../services/peer-review/peer-review.service';
import { PeerReviewersTimingsAndScheduledCallsResponse } from '../../../models/super-admin/peerReviewersTimingsAndScheduledCallsResponse';
import { MessageService } from 'primeng/api';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SchedulePeerCallService } from '../../../services/schedule-peer-call/schedule-peer-call.service';
import { Store } from '@ngxs/store';
import { UserSelectors } from '../../../states/user/user-selector';
import { of, switchMap } from 'rxjs';
import { UserStateModel } from '../../../states/user/user-state-model';
import { AuthRoles } from '../../../models/enums/enums';
import { PeerReviewersTimingsAndScheduledCallsRequest } from '../../../models/super-admin/peerReviewersTimingsAndScheduledCallsRequest';
import { CalendarModule } from 'primeng/calendar';
import { SearchByNameResponse } from '../../../models/account/searchByNameResponse';
import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { UtilityService } from '../../../services/utility/utility.service';

@Component({
  selector: 'app-scheduled-peer-calls',
  standalone: true,
  imports: [ReactiveFormsModule,CommonModule,FormsModule,AutoCompleteModule,InputTextModule, TableModule, ButtonModule, CalendarModule],
  templateUrl: './scheduled-peer-calls.component.html',
  styleUrl: './scheduled-peer-calls.component.scss'
})
export class ScheduledPeerCallsComponent implements OnInit{
  user: UserStateModel | undefined;
  isLoading: boolean = false;
  pageSize = 10;
  first: number = 0;
  rowSize: number = 10;
  totalRecords: number = 0;
  meetingUrlForm!: FormGroup;
  peerListByAdmin: PeerReviewersTimingsAndScheduledCallsResponse [] = [];
  filterForm!: FormGroup;
  peerNames:SearchByNameResponse[] = []
  studentNames:SearchByNameResponse[] = []
  submitted: boolean = false;
  
  constructor(
    private peerReviewService: PeerReviewService,
    private messageService: MessageService,
    private schedulePeerCallService: SchedulePeerCallService,
    private formBuilder: FormBuilder,
    private utilityService: UtilityService,
    private store: Store
  ){}

  initializeForm(){
    this.filterForm = this.formBuilder.group({
      peerName:[null],
      studentName:[null],
      fromDate: [null],
      toDate: [null],
    });
    this.meetingUrlForm = this.formBuilder.group({
      url: this.formBuilder.array([])
    })
  }
  get urlArray(): FormArray{
      return this.meetingUrlForm.get('url') as FormArray;
    }
  getFormControl(index: number): FormControl {
    return this.urlArray.at(index) as FormControl;
  }

  ngOnInit(): void {
    this.initializeForm();
    this.loadPeerCallsByRole(1);
  }
  filterStudentNames(event: AutoCompleteCompleteEvent) {
      if (event.query.length > 2) {
        this.utilityService.searchNamesByRole({
          roleName: 'Student',
          searchText: event.query
        }).subscribe({
          next: (response) => {
            this.studentNames = response.result
          }
        });
      } else {
        this.studentNames = [];
      }
    }

  filterPeerNames(event: AutoCompleteCompleteEvent) {
    if (event.query.length > 2) {
      this.utilityService.searchNamesByRole({
        roleName: 'PeerReviewer',
        searchText: event.query
      }).subscribe({
        next: (response) => {
          this.peerNames = response.result
        }
      });
    } else {
      this.peerNames = [];
    }
  }

  onSendMeetingUrl(index: number){
    const url = this.urlArray.at(index).value;
    const meeting = this.peerListByAdmin[index];

    console.log('Meeting URL:', url);
    console.log('Meeting:', meeting.scheduledCallId);

    this.schedulePeerCallService.setPeerStudentMeetingUrl({
      scheduledCallId: meeting.scheduledCallId,
      meetingUrl: url
    }).subscribe({
      next: (response) => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Meeting Url sent successfully!' });
        this.loadPeerCallsByRole(1);
      }
    })
  }

  loadPeerCallsByRole(pageNumber: Number){
    this.isLoading = true;
    this.store.select(UserSelectors.getUser).pipe(
      switchMap(user => {
        if(!user || !user.id){
          return of(null);
        }
        this.user = user;
        let peerReviewerCallsRequest: PeerReviewersTimingsAndScheduledCallsRequest;
        if(user.role.includes(AuthRoles.SuperAdmin)){
          peerReviewerCallsRequest = {
            peerReviewerName: this.filterForm.value.peerName,
            studentName: this.filterForm.value.studentName,
            startDate: this.filterForm.value.fromDate,
            endDate: this.filterForm.value.toDate,
            pageNumber: pageNumber,
            pageSize: this.rowSize
          };
        } else if (user.role.includes(AuthRoles.Admin)) {
          peerReviewerCallsRequest = {
            peerReviewerName: this.filterForm.value.peerName,
            studentName: this.filterForm.value.studentName,
            startDate: this.filterForm.value.fromDate,
            endDate: this.filterForm.value.toDate,
            adminId: user.id,
            pageNumber: pageNumber,
            pageSize: this.rowSize
          };
        } else {
          return of(null);
        }
        return this.peerReviewService.getPeerReviewerDetailsByAdmin(peerReviewerCallsRequest);
      })
    ).subscribe({
      next:(response) => {
        this.peerListByAdmin = response?.result ?? [];
        this.totalRecords = response?.total ?? 0;
        this.isLoading = false;
        this.initializeForm();

        this.meetingUrlForm.reset();
        this.peerListByAdmin.forEach(meeting => {
          this.urlArray.push(new FormControl(meeting.meetingUrl ??''));
        });   

      }
    })
  }

  onLazyLoad($event: TableLazyLoadEvent): void {
      const pageNumber = Math.floor(($event.first ?? 0) / ($event.rows ?? this.rowSize)) + 1;
      this.first = $event.first ?? 0;
      this.rowSize = $event.rows ?? this.rowSize;
      this.loadPeerCallsByRole(1);
    }
}
